import React from 'react';
import './SoundToggle.css';

const SoundToggle = ({ isSoundEnabled, onToggle }) => {
  return (
    <div className="sound-toggle">
      <button 
        className={`sound-button ${isSoundEnabled ? 'enabled' : 'disabled'}`}
        onClick={onToggle}
        title={isSoundEnabled ? 'Turn sound off' : 'Turn sound on'}
        aria-label={isSoundEnabled ? 'Turn sound off' : 'Turn sound on'}
      >
        <div className="sound-icon">
          {isSoundEnabled ? (
            <>
              <div className="speaker"></div>
              <div className="sound-waves">
                <div className="wave wave-1"></div>
                <div className="wave wave-2"></div>
                <div className="wave wave-3"></div>
              </div>
            </>
          ) : (
            <>
              <div className="speaker"></div>
              <div className="mute-line"></div>
            </>
          )}
        </div>
        <span className="sound-label">
          {isSoundEnabled ? 'Sound On' : 'Sound Off'}
        </span>
      </button>
    </div>
  );
};

export default SoundToggle;
